var Dt = Object.defineProperty;
var qt = (e, t, r) => t in e ? Dt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var O = (e, t, r) => (qt(e, typeof t != "symbol" ? t + "" : t, r), r);
function Pt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function _t(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Oe = { exports: {} }, Ut = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Lt = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
], lt = function(t) {
  var r = t, n = t.indexOf("["), i = t.indexOf("]");
  n != -1 && i != -1 && (t = t.substring(0, n) + t.substring(n, i).replace(/:/g, ";") + t.substring(i, t.length));
  for (var o = Ut.exec(t || ""), s = {}, f = 14; f--; )
    s[Lt[f]] = o[f] || "";
  return n != -1 && i != -1 && (s.source = r, s.host = s.host.substring(1, s.host.length - 1).replace(/;/g, ":"), s.authority = s.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), s.ipv6uri = !0), s.pathNames = Mt(s, s.path), s.queryKey = $t(s, s.query), s;
};
function Mt(e, t) {
  var r = /\/{2,9}/g, n = t.replace(r, "/").split("/");
  return (t.substr(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.substr(t.length - 1, 1) == "/" && n.splice(n.length - 1, 1), n;
}
function $t(e, t) {
  var r = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(n, i, o) {
    i && (r[i] = o);
  }), r;
}
var Ie = { exports: {} }, Re = { exports: {} }, ie = 1e3, oe = ie * 60, se = oe * 60, ae = se * 24, Ht = ae * 365.25, Xt = function(e, t) {
  t = t || {};
  var r = typeof e;
  if (r === "string" && e.length > 0)
    return Wt(e);
  if (r === "number" && isNaN(e) === !1)
    return t.long ? jt(e) : zt(e);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(e)
  );
};
function Wt(e) {
  if (e = String(e), !(e.length > 100)) {
    var t = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      e
    );
    if (t) {
      var r = parseFloat(t[1]), n = (t[2] || "ms").toLowerCase();
      switch (n) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return r * Ht;
        case "days":
        case "day":
        case "d":
          return r * ae;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return r * se;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return r * oe;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return r * ie;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return r;
        default:
          return;
      }
    }
  }
}
function zt(e) {
  return e >= ae ? Math.round(e / ae) + "d" : e >= se ? Math.round(e / se) + "h" : e >= oe ? Math.round(e / oe) + "m" : e >= ie ? Math.round(e / ie) + "s" : e + "ms";
}
function jt(e) {
  return ce(e, ae, "day") || ce(e, se, "hour") || ce(e, oe, "minute") || ce(e, ie, "second") || e + " ms";
}
function ce(e, t, r) {
  if (!(e < t))
    return e < t * 1.5 ? Math.floor(e / t) + " " + r : Math.ceil(e / t) + " " + r + "s";
}
(function(e, t) {
  t = e.exports = n.debug = n.default = n, t.coerce = h, t.disable = s, t.enable = o, t.enabled = f, t.humanize = Xt, t.instances = [], t.names = [], t.skips = [], t.formatters = {};
  function r(u) {
    var p = 0, d;
    for (d in u)
      p = (p << 5) - p + u.charCodeAt(d), p |= 0;
    return t.colors[Math.abs(p) % t.colors.length];
  }
  function n(u) {
    var p;
    function d() {
      if (d.enabled) {
        var y = d, a = +/* @__PURE__ */ new Date(), N = a - (p || a);
        y.diff = N, y.prev = p, y.curr = a, p = a;
        for (var k = new Array(arguments.length), l = 0; l < k.length; l++)
          k[l] = arguments[l];
        k[0] = t.coerce(k[0]), typeof k[0] != "string" && k.unshift("%O");
        var b = 0;
        k[0] = k[0].replace(/%([a-zA-Z%])/g, function(_, c) {
          if (_ === "%%")
            return _;
          b++;
          var g = t.formatters[c];
          if (typeof g == "function") {
            var v = k[b];
            _ = g.call(y, v), k.splice(b, 1), b--;
          }
          return _;
        }), t.formatArgs.call(y, k);
        var I = d.log || t.log || console.log.bind(console);
        I.apply(y, k);
      }
    }
    return d.namespace = u, d.enabled = t.enabled(u), d.useColors = t.useColors(), d.color = r(u), d.destroy = i, typeof t.init == "function" && t.init(d), t.instances.push(d), d;
  }
  function i() {
    var u = t.instances.indexOf(this);
    return u !== -1 ? (t.instances.splice(u, 1), !0) : !1;
  }
  function o(u) {
    t.save(u), t.names = [], t.skips = [];
    var p, d = (typeof u == "string" ? u : "").split(/[\s,]+/), y = d.length;
    for (p = 0; p < y; p++)
      d[p] && (u = d[p].replace(/\*/g, ".*?"), u[0] === "-" ? t.skips.push(new RegExp("^" + u.substr(1) + "$")) : t.names.push(new RegExp("^" + u + "$")));
    for (p = 0; p < t.instances.length; p++) {
      var a = t.instances[p];
      a.enabled = t.enabled(a.namespace);
    }
  }
  function s() {
    t.enable("");
  }
  function f(u) {
    if (u[u.length - 1] === "*")
      return !0;
    var p, d;
    for (p = 0, d = t.skips.length; p < d; p++)
      if (t.skips[p].test(u))
        return !1;
    for (p = 0, d = t.names.length; p < d; p++)
      if (t.names[p].test(u))
        return !0;
    return !1;
  }
  function h(u) {
    return u instanceof Error ? u.stack || u.message : u;
  }
})(Re, Re.exports);
var Jt = Re.exports;
(function(e, t) {
  t = e.exports = Jt, t.log = i, t.formatArgs = n, t.save = o, t.load = s, t.useColors = r, t.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : f(), t.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  t.formatters.j = function(h) {
    try {
      return JSON.stringify(h);
    } catch (u) {
      return "[UnexpectedJSONParseError]: " + u.message;
    }
  };
  function n(h) {
    var u = this.useColors;
    if (h[0] = (u ? "%c" : "") + this.namespace + (u ? " %c" : " ") + h[0] + (u ? "%c " : " ") + "+" + t.humanize(this.diff), !!u) {
      var p = "color: " + this.color;
      h.splice(1, 0, p, "color: inherit");
      var d = 0, y = 0;
      h[0].replace(/%[a-zA-Z%]/g, function(a) {
        a !== "%%" && (d++, a === "%c" && (y = d));
      }), h.splice(y, 0, p);
    }
  }
  function i() {
    return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function o(h) {
    try {
      h == null ? t.storage.removeItem("debug") : t.storage.debug = h;
    } catch {
    }
  }
  function s() {
    var h;
    try {
      h = t.storage.debug;
    } catch {
    }
    return !h && typeof process < "u" && "env" in process && (h = process.env.DEBUG), h;
  }
  t.enable(s());
  function f() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})(Ie, Ie.exports);
var X = Ie.exports, Vt = lt, Ve = X("socket.io-client:url"), Gt = Kt;
function Kt(e, t) {
  var r = e;
  t = t || typeof location < "u" && location, e == null && (e = t.protocol + "//" + t.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = t.protocol + e : e = t.host + e), /^(https?|wss?):\/\//.test(e) || (Ve("protocol-less url %s", e), typeof t < "u" ? e = t.protocol + "//" + e : e = "https://" + e), Ve("parse %s", e), r = Vt(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  var n = r.host.indexOf(":") !== -1, i = n ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + i + ":" + r.port, r.href = r.protocol + "://" + i + (t && t.port === r.port ? "" : ":" + r.port), r;
}
var ve = {}, pt = { exports: {} };
(function(e) {
  e.exports = t;
  function t(n) {
    if (n)
      return r(n);
  }
  function r(n) {
    for (var i in t.prototype)
      n[i] = t.prototype[i];
    return n;
  }
  t.prototype.on = t.prototype.addEventListener = function(n, i) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + n] = this._callbacks["$" + n] || []).push(i), this;
  }, t.prototype.once = function(n, i) {
    function o() {
      this.off(n, o), i.apply(this, arguments);
    }
    return o.fn = i, this.on(n, o), this;
  }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function(n, i) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var o = this._callbacks["$" + n];
    if (!o)
      return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + n], this;
    for (var s, f = 0; f < o.length; f++)
      if (s = o[f], s === i || s.fn === i) {
        o.splice(f, 1);
        break;
      }
    return o.length === 0 && delete this._callbacks["$" + n], this;
  }, t.prototype.emit = function(n) {
    this._callbacks = this._callbacks || {};
    for (var i = new Array(arguments.length - 1), o = this._callbacks["$" + n], s = 1; s < arguments.length; s++)
      i[s - 1] = arguments[s];
    if (o) {
      o = o.slice(0);
      for (var s = 0, f = o.length; s < f; ++s)
        o[s].apply(this, i);
    }
    return this;
  }, t.prototype.listeners = function(n) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + n] || [];
  }, t.prototype.hasListeners = function(n) {
    return !!this.listeners(n).length;
  };
})(pt);
var ee = pt.exports, me = {}, Yt = {}.toString, _e = Array.isArray || function(e) {
  return Yt.call(e) == "[object Array]";
}, dt = tr, Qt = typeof Buffer == "function" && typeof Buffer.isBuffer == "function", Zt = typeof ArrayBuffer == "function", er = function(e) {
  return typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer;
};
function tr(e) {
  return Qt && Buffer.isBuffer(e) || Zt && (e instanceof ArrayBuffer || er(e));
}
var Ue = _e, yt = dt, gt = Object.prototype.toString, rr = typeof Blob == "function" || typeof Blob < "u" && gt.call(Blob) === "[object BlobConstructor]", nr = typeof File == "function" || typeof File < "u" && gt.call(File) === "[object FileConstructor]";
me.deconstructPacket = function(e) {
  var t = [], r = e.data, n = e;
  return n.data = xe(r, t), n.attachments = t.length, { packet: n, buffers: t };
};
function xe(e, t) {
  if (!e)
    return e;
  if (yt(e)) {
    var r = { _placeholder: !0, num: t.length };
    return t.push(e), r;
  } else if (Ue(e)) {
    for (var n = new Array(e.length), i = 0; i < e.length; i++)
      n[i] = xe(e[i], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    var n = {};
    for (var o in e)
      n[o] = xe(e[o], t);
    return n;
  }
  return e;
}
me.reconstructPacket = function(e, t) {
  return e.data = Te(e.data, t), e.attachments = void 0, e;
};
function Te(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    var r = typeof e.num == "number" && e.num >= 0 && e.num < t.length;
    if (r)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Ue(e))
    for (var n = 0; n < e.length; n++)
      e[n] = Te(e[n], t);
  else if (typeof e == "object")
    for (var i in e)
      e[i] = Te(e[i], t);
  return e;
}
me.removeBlobs = function(e, t) {
  function r(o, s, f) {
    if (!o)
      return o;
    if (rr && o instanceof Blob || nr && o instanceof File) {
      n++;
      var h = new FileReader();
      h.onload = function() {
        f ? f[s] = this.result : i = this.result, --n || t(i);
      }, h.readAsArrayBuffer(o);
    } else if (Ue(o))
      for (var u = 0; u < o.length; u++)
        r(o[u], u, o);
    else if (typeof o == "object" && !yt(o))
      for (var p in o)
        r(o[p], p, o);
  }
  var n = 0, i = e;
  r(i), n || t(i);
};
(function(e) {
  var t = X("socket.io-parser"), r = ee, n = me, i = _e, o = dt;
  e.protocol = 4, e.types = [
    "CONNECT",
    "DISCONNECT",
    "EVENT",
    "ACK",
    "ERROR",
    "BINARY_EVENT",
    "BINARY_ACK"
  ], e.CONNECT = 0, e.DISCONNECT = 1, e.EVENT = 2, e.ACK = 3, e.ERROR = 4, e.BINARY_EVENT = 5, e.BINARY_ACK = 6, e.Encoder = s, e.Decoder = d;
  function s() {
  }
  var f = e.ERROR + '"encode error"';
  s.prototype.encode = function(l, b) {
    if (t("encoding packet %j", l), e.BINARY_EVENT === l.type || e.BINARY_ACK === l.type)
      p(l, b);
    else {
      var I = h(l);
      b([I]);
    }
  };
  function h(l) {
    var b = "" + l.type;
    if ((e.BINARY_EVENT === l.type || e.BINARY_ACK === l.type) && (b += l.attachments + "-"), l.nsp && l.nsp !== "/" && (b += l.nsp + ","), l.id != null && (b += l.id), l.data != null) {
      var I = u(l.data);
      if (I !== !1)
        b += I;
      else
        return f;
    }
    return t("encoded %j as %s", l, b), b;
  }
  function u(l) {
    try {
      return JSON.stringify(l);
    } catch {
      return !1;
    }
  }
  function p(l, b) {
    function I(_) {
      var c = n.deconstructPacket(_), g = h(c.packet), v = c.buffers;
      v.unshift(g), b(v);
    }
    n.removeBlobs(l, I);
  }
  function d() {
    this.reconstructor = null;
  }
  r(d.prototype), d.prototype.add = function(l) {
    var b;
    if (typeof l == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      b = y(l), e.BINARY_EVENT === b.type || e.BINARY_ACK === b.type ? (this.reconstructor = new N(b), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", b)) : this.emit("decoded", b);
    } else if (o(l) || l.base64)
      if (this.reconstructor)
        b = this.reconstructor.takeBinaryData(l), b && (this.reconstructor = null, this.emit("decoded", b));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + l);
  };
  function y(l) {
    var b = 0, I = {
      type: Number(l.charAt(0))
    };
    if (e.types[I.type] == null)
      return k("unknown packet type " + I.type);
    if (e.BINARY_EVENT === I.type || e.BINARY_ACK === I.type) {
      for (var _ = b + 1; l.charAt(++b) !== "-" && b != l.length; )
        ;
      var c = l.substring(_, b);
      if (c != Number(c) || l.charAt(b) !== "-")
        throw new Error("Illegal attachments");
      I.attachments = Number(c);
    }
    if (l.charAt(b + 1) === "/") {
      for (var _ = b + 1; ++b; ) {
        var g = l.charAt(b);
        if (g === "," || b === l.length)
          break;
      }
      I.nsp = l.substring(_, b);
    } else
      I.nsp = "/";
    var v = l.charAt(b + 1);
    if (v !== "" && Number(v) == v) {
      for (var _ = b + 1; ++b; ) {
        var g = l.charAt(b);
        if (g == null || Number(g) != g) {
          --b;
          break;
        }
        if (b === l.length)
          break;
      }
      I.id = Number(l.substring(_, b + 1));
    }
    if (l.charAt(++b)) {
      var m = a(l.substr(b)), w = m !== !1 && (I.type === e.ERROR || i(m));
      if (w)
        I.data = m;
      else
        return k("invalid payload");
    }
    return t("decoded %s as %j", l, I), I;
  }
  function a(l) {
    try {
      return JSON.parse(l);
    } catch {
      return !1;
    }
  }
  d.prototype.destroy = function() {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  };
  function N(l) {
    this.reconPack = l, this.buffers = [];
  }
  N.prototype.takeBinaryData = function(l) {
    if (this.buffers.push(l), this.buffers.length === this.reconPack.attachments) {
      var b = n.reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), b;
    }
    return null;
  }, N.prototype.finishedReconstruction = function() {
    this.reconPack = null, this.buffers = [];
  };
  function k(l) {
    return {
      type: e.ERROR,
      data: "parser error: " + l
    };
  }
})(ve);
var Le = { exports: {} }, be = {}, De = { exports: {} };
try {
  De.exports = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
  De.exports = !1;
}
var ir = De.exports, Me = function() {
  return typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
}(), or = ir, sr = Me, $e = function(e) {
  var t = e.xdomain, r = e.xscheme, n = e.enablesXDR;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || or))
      return new XMLHttpRequest();
  } catch {
  }
  try {
    if (typeof XDomainRequest < "u" && !r && n)
      return new XDomainRequest();
  } catch {
  }
  if (!t)
    try {
      return new sr[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}, He = { exports: {} }, K = {}, ar = Object.keys || function(t) {
  var r = [], n = Object.prototype.hasOwnProperty;
  for (var i in t)
    n.call(t, i) && r.push(i);
  return r;
}, Ae, Ge;
function vt() {
  if (Ge)
    return Ae;
  Ge = 1;
  var e = _e, t = Object.prototype.toString, r = typeof Blob == "function" || typeof Blob < "u" && t.call(Blob) === "[object BlobConstructor]", n = typeof File == "function" || typeof File < "u" && t.call(File) === "[object FileConstructor]";
  Ae = i;
  function i(o) {
    if (!o || typeof o != "object")
      return !1;
    if (e(o)) {
      for (var s = 0, f = o.length; s < f; s++)
        if (i(o[s]))
          return !0;
      return !1;
    }
    if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(o) || typeof ArrayBuffer == "function" && o instanceof ArrayBuffer || r && o instanceof Blob || n && o instanceof File)
      return !0;
    if (o.toJSON && typeof o.toJSON == "function" && arguments.length === 1)
      return i(o.toJSON(), !0);
    for (var h in o)
      if (Object.prototype.hasOwnProperty.call(o, h) && i(o[h]))
        return !0;
    return !1;
  }
  return Ae;
}
var cr = function(e, t, r) {
  var n = e.byteLength;
  if (t = t || 0, r = r || n, e.slice)
    return e.slice(t, r);
  if (t < 0 && (t += n), r < 0 && (r += n), r > n && (r = n), t >= n || t >= r || n === 0)
    return new ArrayBuffer(0);
  for (var i = new Uint8Array(e), o = new Uint8Array(r - t), s = t, f = 0; s < r; s++, f++)
    o[f] = i[s];
  return o.buffer;
}, ur = fr;
function fr(e, t, r) {
  var n = !1;
  return r = r || hr, i.count = e, e === 0 ? t() : i;
  function i(o, s) {
    if (i.count <= 0)
      throw new Error("after called too many times");
    --i.count, o ? (n = !0, t(o), t = r) : i.count === 0 && !n && t(null, s);
  }
}
function hr() {
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var z = String.fromCharCode;
function mt(e) {
  for (var t = [], r = 0, n = e.length, i, o; r < n; )
    i = e.charCodeAt(r++), i >= 55296 && i <= 56319 && r < n ? (o = e.charCodeAt(r++), (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), r--)) : t.push(i);
  return t;
}
function lr(e) {
  for (var t = e.length, r = -1, n, i = ""; ++r < t; )
    n = e[r], n > 65535 && (n -= 65536, i += z(n >>> 10 & 1023 | 55296), n = 56320 | n & 1023), i += z(n);
  return i;
}
function bt(e, t) {
  if (e >= 55296 && e <= 57343) {
    if (t)
      throw Error(
        "Lone surrogate U+" + e.toString(16).toUpperCase() + " is not a scalar value"
      );
    return !1;
  }
  return !0;
}
function Ee(e, t) {
  return z(e >> t & 63 | 128);
}
function pr(e, t) {
  if (!(e & 4294967168))
    return z(e);
  var r = "";
  return e & 4294965248 ? e & 4294901760 ? e & 4292870144 || (r = z(e >> 18 & 7 | 240), r += Ee(e, 12), r += Ee(e, 6)) : (bt(e, t) || (e = 65533), r = z(e >> 12 & 15 | 224), r += Ee(e, 6)) : r = z(e >> 6 & 31 | 192), r += z(e & 63 | 128), r;
}
function dr(e, t) {
  t = t || {};
  for (var r = t.strict !== !1, n = mt(e), i = n.length, o = -1, s, f = ""; ++o < i; )
    s = n[o], f += pr(s, r);
  return f;
}
function Y() {
  if (j >= de)
    throw Error("Invalid byte index");
  var e = pe[j] & 255;
  if (j++, (e & 192) == 128)
    return e & 63;
  throw Error("Invalid continuation byte");
}
function yr(e) {
  var t, r, n, i, o;
  if (j > de)
    throw Error("Invalid byte index");
  if (j == de)
    return !1;
  if (t = pe[j] & 255, j++, !(t & 128))
    return t;
  if ((t & 224) == 192) {
    if (r = Y(), o = (t & 31) << 6 | r, o >= 128)
      return o;
    throw Error("Invalid continuation byte");
  }
  if ((t & 240) == 224) {
    if (r = Y(), n = Y(), o = (t & 15) << 12 | r << 6 | n, o >= 2048)
      return bt(o, e) ? o : 65533;
    throw Error("Invalid continuation byte");
  }
  if ((t & 248) == 240 && (r = Y(), n = Y(), i = Y(), o = (t & 7) << 18 | r << 12 | n << 6 | i, o >= 65536 && o <= 1114111))
    return o;
  throw Error("Invalid UTF-8 detected");
}
var pe, de, j;
function gr(e, t) {
  t = t || {};
  var r = t.strict !== !1;
  pe = mt(e), de = pe.length, j = 0;
  for (var n = [], i; (i = yr(r)) !== !1; )
    n.push(i);
  return lr(n);
}
var vr = {
  version: "2.1.2",
  encode: dr,
  decode: gr
}, ue = {}, Ke;
function mr() {
  return Ke || (Ke = 1, function(e) {
    ue.encode = function(t) {
      var r = new Uint8Array(t), n, i = r.length, o = "";
      for (n = 0; n < i; n += 3)
        o += e[r[n] >> 2], o += e[(r[n] & 3) << 4 | r[n + 1] >> 4], o += e[(r[n + 1] & 15) << 2 | r[n + 2] >> 6], o += e[r[n + 2] & 63];
      return i % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : i % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
    }, ue.decode = function(t) {
      var r = t.length * 0.75, n = t.length, i, o = 0, s, f, h, u;
      t[t.length - 1] === "=" && (r--, t[t.length - 2] === "=" && r--);
      var p = new ArrayBuffer(r), d = new Uint8Array(p);
      for (i = 0; i < n; i += 4)
        s = e.indexOf(t[i]), f = e.indexOf(t[i + 1]), h = e.indexOf(t[i + 2]), u = e.indexOf(t[i + 3]), d[o++] = s << 2 | f >> 4, d[o++] = (f & 15) << 4 | h >> 2, d[o++] = (h & 3) << 6 | u & 63;
      return p;
    };
  }("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")), ue;
}
var Be, Ye;
function br() {
  if (Ye)
    return Be;
  Ye = 1;
  var e = typeof e < "u" ? e : typeof WebKitBlobBuilder < "u" ? WebKitBlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : !1, t = function() {
    try {
      var f = new Blob(["hi"]);
      return f.size === 2;
    } catch {
      return !1;
    }
  }(), r = t && function() {
    try {
      var f = new Blob([new Uint8Array([1, 2])]);
      return f.size === 2;
    } catch {
      return !1;
    }
  }(), n = e && e.prototype.append && e.prototype.getBlob;
  function i(f) {
    return f.map(function(h) {
      if (h.buffer instanceof ArrayBuffer) {
        var u = h.buffer;
        if (h.byteLength !== u.byteLength) {
          var p = new Uint8Array(h.byteLength);
          p.set(new Uint8Array(u, h.byteOffset, h.byteLength)), u = p.buffer;
        }
        return u;
      }
      return h;
    });
  }
  function o(f, h) {
    h = h || {};
    var u = new e();
    return i(f).forEach(function(p) {
      u.append(p);
    }), h.type ? u.getBlob(h.type) : u.getBlob();
  }
  function s(f, h) {
    return new Blob(i(f), h || {});
  }
  return typeof Blob < "u" && (o.prototype = Blob.prototype, s.prototype = Blob.prototype), Be = /* @__PURE__ */ function() {
    return t ? r ? Blob : s : n ? o : void 0;
  }(), Be;
}
(function(e) {
  var t = ar, r = vt(), n = cr, i = ur, o = vr, s;
  typeof ArrayBuffer < "u" && (s = mr());
  var f = typeof navigator < "u" && /Android/i.test(navigator.userAgent), h = typeof navigator < "u" && /PhantomJS/i.test(navigator.userAgent), u = f || h;
  e.protocol = 3;
  var p = e.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  }, d = t(p), y = { type: "error", data: "parser error" }, a = br();
  e.encodePacket = function(c, g, v, m) {
    typeof g == "function" && (m = g, g = !1), typeof v == "function" && (m = v, v = null);
    var w = c.data === void 0 ? void 0 : c.data.buffer || c.data;
    if (typeof ArrayBuffer < "u" && w instanceof ArrayBuffer)
      return k(c, g, m);
    if (typeof a < "u" && w instanceof a)
      return b(c, g, m);
    if (w && w.base64)
      return N(c, m);
    var C = p[c.type];
    return c.data !== void 0 && (C += v ? o.encode(String(c.data), { strict: !1 }) : String(c.data)), m("" + C);
  };
  function N(c, g) {
    var v = "b" + e.packets[c.type] + c.data.data;
    return g(v);
  }
  function k(c, g, v) {
    if (!g)
      return e.encodeBase64Packet(c, v);
    var m = c.data, w = new Uint8Array(m), C = new Uint8Array(1 + m.byteLength);
    C[0] = p[c.type];
    for (var A = 0; A < w.length; A++)
      C[A + 1] = w[A];
    return v(C.buffer);
  }
  function l(c, g, v) {
    if (!g)
      return e.encodeBase64Packet(c, v);
    var m = new FileReader();
    return m.onload = function() {
      e.encodePacket({ type: c.type, data: m.result }, g, !0, v);
    }, m.readAsArrayBuffer(c.data);
  }
  function b(c, g, v) {
    if (!g)
      return e.encodeBase64Packet(c, v);
    if (u)
      return l(c, g, v);
    var m = new Uint8Array(1);
    m[0] = p[c.type];
    var w = new a([m.buffer, c.data]);
    return v(w);
  }
  e.encodeBase64Packet = function(c, g) {
    var v = "b" + e.packets[c.type];
    if (typeof a < "u" && c.data instanceof a) {
      var m = new FileReader();
      return m.onload = function() {
        var E = m.result.split(",")[1];
        g(v + E);
      }, m.readAsDataURL(c.data);
    }
    var w;
    try {
      w = String.fromCharCode.apply(null, new Uint8Array(c.data));
    } catch {
      for (var C = new Uint8Array(c.data), A = new Array(C.length), S = 0; S < C.length; S++)
        A[S] = C[S];
      w = String.fromCharCode.apply(null, A);
    }
    return v += btoa(w), g(v);
  }, e.decodePacket = function(c, g, v) {
    if (c === void 0)
      return y;
    if (typeof c == "string") {
      if (c.charAt(0) === "b")
        return e.decodeBase64Packet(c.substr(1), g);
      if (v && (c = I(c), c === !1))
        return y;
      var w = c.charAt(0);
      return Number(w) != w || !d[w] ? y : c.length > 1 ? { type: d[w], data: c.substring(1) } : { type: d[w] };
    }
    var m = new Uint8Array(c), w = m[0], C = n(c, 1);
    return a && g === "blob" && (C = new a([C])), { type: d[w], data: C };
  };
  function I(c) {
    try {
      c = o.decode(c, { strict: !1 });
    } catch {
      return !1;
    }
    return c;
  }
  e.decodeBase64Packet = function(c, g) {
    var v = d[c.charAt(0)];
    if (!s)
      return { type: v, data: { base64: !0, data: c.substr(1) } };
    var m = s.decode(c.substr(1));
    return g === "blob" && a && (m = new a([m])), { type: v, data: m };
  }, e.encodePayload = function(c, g, v) {
    typeof g == "function" && (v = g, g = null);
    var m = r(c);
    if (g && m)
      return a && !u ? e.encodePayloadAsBlob(c, v) : e.encodePayloadAsArrayBuffer(c, v);
    if (!c.length)
      return v("0:");
    function w(A) {
      return A.length + ":" + A;
    }
    function C(A, S) {
      e.encodePacket(A, m ? g : !1, !1, function(E) {
        S(null, w(E));
      });
    }
    _(c, C, function(A, S) {
      return v(S.join(""));
    });
  };
  function _(c, g, v) {
    for (var m = new Array(c.length), w = i(c.length, v), C = function(S, E, R) {
      g(E, function(x, T) {
        m[S] = T, R(x, m);
      });
    }, A = 0; A < c.length; A++)
      C(A, c[A], w);
  }
  e.decodePayload = function(c, g, v) {
    if (typeof c != "string")
      return e.decodePayloadAsBinary(c, g, v);
    typeof g == "function" && (v = g, g = null);
    var m;
    if (c === "")
      return v(y, 0, 1);
    for (var w = "", C, A, S = 0, E = c.length; S < E; S++) {
      var R = c.charAt(S);
      if (R !== ":") {
        w += R;
        continue;
      }
      if (w === "" || w != (C = Number(w)) || (A = c.substr(S + 1, C), w != A.length))
        return v(y, 0, 1);
      if (A.length) {
        if (m = e.decodePacket(A, g, !1), y.type === m.type && y.data === m.data)
          return v(y, 0, 1);
        var x = v(m, S + C, E);
        if (x === !1)
          return;
      }
      S += C, w = "";
    }
    if (w !== "")
      return v(y, 0, 1);
  }, e.encodePayloadAsArrayBuffer = function(c, g) {
    if (!c.length)
      return g(new ArrayBuffer(0));
    function v(m, w) {
      e.encodePacket(m, !0, !0, function(C) {
        return w(null, C);
      });
    }
    _(c, v, function(m, w) {
      var C = w.reduce(function(E, R) {
        var x;
        return typeof R == "string" ? x = R.length : x = R.byteLength, E + x.toString().length + x + 2;
      }, 0), A = new Uint8Array(C), S = 0;
      return w.forEach(function(E) {
        var R = typeof E == "string", x = E;
        if (R) {
          for (var G = new Uint8Array(E.length), T = 0; T < E.length; T++)
            G[T] = E.charCodeAt(T);
          x = G.buffer;
        }
        R ? A[S++] = 0 : A[S++] = 1;
        for (var V = x.byteLength.toString(), T = 0; T < V.length; T++)
          A[S++] = parseInt(V[T]);
        A[S++] = 255;
        for (var G = new Uint8Array(x), T = 0; T < G.length; T++)
          A[S++] = G[T];
      }), g(A.buffer);
    });
  }, e.encodePayloadAsBlob = function(c, g) {
    function v(m, w) {
      e.encodePacket(m, !0, !0, function(C) {
        var A = new Uint8Array(1);
        if (A[0] = 1, typeof C == "string") {
          for (var S = new Uint8Array(C.length), E = 0; E < C.length; E++)
            S[E] = C.charCodeAt(E);
          C = S.buffer, A[0] = 0;
        }
        for (var R = C instanceof ArrayBuffer ? C.byteLength : C.size, x = R.toString(), T = new Uint8Array(x.length + 1), E = 0; E < x.length; E++)
          T[E] = parseInt(x[E]);
        if (T[x.length] = 255, a) {
          var V = new a([A.buffer, T.buffer, C]);
          w(null, V);
        }
      });
    }
    _(c, v, function(m, w) {
      return g(new a(w));
    });
  }, e.decodePayloadAsBinary = function(c, g, v) {
    typeof g == "function" && (v = g, g = null);
    for (var m = c, w = []; m.byteLength > 0; ) {
      for (var C = new Uint8Array(m), A = C[0] === 0, S = "", E = 1; C[E] !== 255; E++) {
        if (S.length > 310)
          return v(y, 0, 1);
        S += C[E];
      }
      m = n(m, 2 + S.length), S = parseInt(S);
      var R = n(m, 0, S);
      if (A)
        try {
          R = String.fromCharCode.apply(null, new Uint8Array(R));
        } catch {
          var x = new Uint8Array(R);
          R = "";
          for (var E = 0; E < x.length; E++)
            R += String.fromCharCode(x[E]);
        }
      w.push(R), m = n(m, S);
    }
    var T = w.length;
    w.forEach(function(V, G) {
      v(e.decodePacket(V, g, !0), G, T);
    });
  };
})(K);
var ke, Qe;
function Xe() {
  if (Qe)
    return ke;
  Qe = 1;
  var e = K, t = ee;
  ke = r;
  function r(n) {
    this.path = n.path, this.hostname = n.hostname, this.port = n.port, this.secure = n.secure, this.query = n.query, this.timestampParam = n.timestampParam, this.timestampRequests = n.timestampRequests, this.readyState = "", this.agent = n.agent || !1, this.socket = n.socket, this.enablesXDR = n.enablesXDR, this.withCredentials = n.withCredentials, this.pfx = n.pfx, this.key = n.key, this.passphrase = n.passphrase, this.cert = n.cert, this.ca = n.ca, this.ciphers = n.ciphers, this.rejectUnauthorized = n.rejectUnauthorized, this.forceNode = n.forceNode, this.isReactNative = n.isReactNative, this.extraHeaders = n.extraHeaders, this.localAddress = n.localAddress;
  }
  return t(r.prototype), r.prototype.onError = function(n, i) {
    var o = new Error(n);
    return o.type = "TransportError", o.description = i, this.emit("error", o), this;
  }, r.prototype.open = function() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }, r.prototype.close = function() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }, r.prototype.send = function(n) {
    if (this.readyState === "open")
      this.write(n);
    else
      throw new Error("Transport not open");
  }, r.prototype.onOpen = function() {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, r.prototype.onData = function(n) {
    var i = e.decodePacket(n, this.socket.binaryType);
    this.onPacket(i);
  }, r.prototype.onPacket = function(n) {
    this.emit("packet", n);
  }, r.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  }, ke;
}
var fe = {}, Ze;
function we() {
  return Ze || (Ze = 1, fe.encode = function(e) {
    var t = "";
    for (var r in e)
      e.hasOwnProperty(r) && (t.length && (t += "&"), t += encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
    return t;
  }, fe.decode = function(e) {
    for (var t = {}, r = e.split("&"), n = 0, i = r.length; n < i; n++) {
      var o = r[n].split("=");
      t[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
    }
    return t;
  }), fe;
}
var Ce = function(e, t) {
  var r = function() {
  };
  r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
}, wt = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), ye = 64, Ct = {}, et = 0, J = 0, tt;
function qe(e) {
  var t = "";
  do
    t = wt[e % ye] + t, e = Math.floor(e / ye);
  while (e > 0);
  return t;
}
function wr(e) {
  var t = 0;
  for (J = 0; J < e.length; J++)
    t = t * ye + Ct[e.charAt(J)];
  return t;
}
function We() {
  var e = qe(+/* @__PURE__ */ new Date());
  return e !== tt ? (et = 0, tt = e) : e + "." + qe(et++);
}
for (; J < ye; J++)
  Ct[wt[J]] = J;
We.encode = qe;
We.decode = wr;
var At = We, Et = Xe(), Cr = we(), Bt = K, Ar = Ce, Er = At, $ = X("engine.io-client:polling"), kt = H, Br = function() {
  var e = $e, t = new e({ xdomain: !1 });
  return t.responseType != null;
}();
function H(e) {
  var t = e && e.forceBase64;
  (!Br || t) && (this.supportsBinary = !1), Et.call(this, e);
}
Ar(H, Et);
H.prototype.name = "polling";
H.prototype.doOpen = function() {
  this.poll();
};
H.prototype.pause = function(e) {
  var t = this;
  this.readyState = "pausing";
  function r() {
    $("paused"), t.readyState = "paused", e();
  }
  if (this.polling || !this.writable) {
    var n = 0;
    this.polling && ($("we are currently polling - waiting to pause"), n++, this.once("pollComplete", function() {
      $("pre-pause polling complete"), --n || r();
    })), this.writable || ($("we are currently writing - waiting to pause"), n++, this.once("drain", function() {
      $("pre-pause writing complete"), --n || r();
    }));
  } else
    r();
};
H.prototype.poll = function() {
  $("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
};
H.prototype.onData = function(e) {
  var t = this;
  $("polling got data %s", e);
  var r = function(n, i, o) {
    if (t.readyState === "opening" && n.type === "open" && t.onOpen(), n.type === "close")
      return t.onClose(), !1;
    t.onPacket(n);
  };
  Bt.decodePayload(e, this.socket.binaryType, r), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : $('ignoring poll - transport state "%s"', this.readyState));
};
H.prototype.doClose = function() {
  var e = this;
  function t() {
    $("writing close packet"), e.write([{ type: "close" }]);
  }
  this.readyState === "open" ? ($("transport open - closing"), t()) : ($("transport not open - deferring close"), this.once("open", t));
};
H.prototype.write = function(e) {
  var t = this;
  this.writable = !1;
  var r = function() {
    t.writable = !0, t.emit("drain");
  };
  Bt.encodePayload(e, this.supportsBinary, function(n) {
    t.doWrite(n, r);
  });
};
H.prototype.uri = function() {
  var e = this.query || {}, t = this.secure ? "https" : "http", r = "";
  this.timestampRequests !== !1 && (e[this.timestampParam] = Er()), !this.supportsBinary && !e.sid && (e.b64 = 1), e = Cr.encode(e), this.port && (t === "https" && Number(this.port) !== 443 || t === "http" && Number(this.port) !== 80) && (r = ":" + this.port), e.length && (e = "?" + e);
  var n = this.hostname.indexOf(":") !== -1;
  return t + "://" + (n ? "[" + this.hostname + "]" : this.hostname) + r + this.path + e;
};
var kr = $e, St = kt, Sr = ee, Fr = Ce, Pe = X("engine.io-client:polling-xhr"), Nr = Me;
He.exports = te;
He.exports.Request = q;
function rt() {
}
function te(e) {
  if (St.call(this, e), this.requestTimeout = e.requestTimeout, this.extraHeaders = e.extraHeaders, typeof location < "u") {
    var t = location.protocol === "https:", r = location.port;
    r || (r = t ? 443 : 80), this.xd = typeof location < "u" && e.hostname !== location.hostname || r !== e.port, this.xs = e.secure !== t;
  }
}
Fr(te, St);
te.prototype.supportsBinary = !0;
te.prototype.request = function(e) {
  return e = e || {}, e.uri = this.uri(), e.xd = this.xd, e.xs = this.xs, e.agent = this.agent || !1, e.supportsBinary = this.supportsBinary, e.enablesXDR = this.enablesXDR, e.withCredentials = this.withCredentials, e.pfx = this.pfx, e.key = this.key, e.passphrase = this.passphrase, e.cert = this.cert, e.ca = this.ca, e.ciphers = this.ciphers, e.rejectUnauthorized = this.rejectUnauthorized, e.requestTimeout = this.requestTimeout, e.extraHeaders = this.extraHeaders, new q(e);
};
te.prototype.doWrite = function(e, t) {
  var r = typeof e != "string" && e !== void 0, n = this.request({ method: "POST", data: e, isBinary: r }), i = this;
  n.on("success", t), n.on("error", function(o) {
    i.onError("xhr post error", o);
  }), this.sendXhr = n;
};
te.prototype.doPoll = function() {
  Pe("xhr poll");
  var e = this.request(), t = this;
  e.on("data", function(r) {
    t.onData(r);
  }), e.on("error", function(r) {
    t.onError("xhr poll error", r);
  }), this.pollXhr = e;
};
function q(e) {
  this.method = e.method || "GET", this.uri = e.uri, this.xd = !!e.xd, this.xs = !!e.xs, this.async = e.async !== !1, this.data = e.data !== void 0 ? e.data : null, this.agent = e.agent, this.isBinary = e.isBinary, this.supportsBinary = e.supportsBinary, this.enablesXDR = e.enablesXDR, this.withCredentials = e.withCredentials, this.requestTimeout = e.requestTimeout, this.pfx = e.pfx, this.key = e.key, this.passphrase = e.passphrase, this.cert = e.cert, this.ca = e.ca, this.ciphers = e.ciphers, this.rejectUnauthorized = e.rejectUnauthorized, this.extraHeaders = e.extraHeaders, this.create();
}
Sr(q.prototype);
q.prototype.create = function() {
  var e = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
  e.pfx = this.pfx, e.key = this.key, e.passphrase = this.passphrase, e.cert = this.cert, e.ca = this.ca, e.ciphers = this.ciphers, e.rejectUnauthorized = this.rejectUnauthorized;
  var t = this.xhr = new kr(e), r = this;
  try {
    Pe("xhr open %s: %s", this.method, this.uri), t.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        t.setDisableHeaderCheck && t.setDisableHeaderCheck(!0);
        for (var n in this.extraHeaders)
          this.extraHeaders.hasOwnProperty(n) && t.setRequestHeader(n, this.extraHeaders[n]);
      }
    } catch {
    }
    if (this.method === "POST")
      try {
        this.isBinary ? t.setRequestHeader("Content-type", "application/octet-stream") : t.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
      } catch {
      }
    try {
      t.setRequestHeader("Accept", "*/*");
    } catch {
    }
    "withCredentials" in t && (t.withCredentials = this.withCredentials), this.requestTimeout && (t.timeout = this.requestTimeout), this.hasXDR() ? (t.onload = function() {
      r.onLoad();
    }, t.onerror = function() {
      r.onError(t.responseText);
    }) : t.onreadystatechange = function() {
      if (t.readyState === 2)
        try {
          var i = t.getResponseHeader("Content-Type");
          (r.supportsBinary && i === "application/octet-stream" || i === "application/octet-stream; charset=UTF-8") && (t.responseType = "arraybuffer");
        } catch {
        }
      t.readyState === 4 && (t.status === 200 || t.status === 1223 ? r.onLoad() : setTimeout(function() {
        r.onError(typeof t.status == "number" ? t.status : 0);
      }, 0));
    }, Pe("xhr data %s", this.data), t.send(this.data);
  } catch (i) {
    setTimeout(function() {
      r.onError(i);
    }, 0);
    return;
  }
  typeof document < "u" && (this.index = q.requestsCount++, q.requests[this.index] = this);
};
q.prototype.onSuccess = function() {
  this.emit("success"), this.cleanup();
};
q.prototype.onData = function(e) {
  this.emit("data", e), this.onSuccess();
};
q.prototype.onError = function(e) {
  this.emit("error", e), this.cleanup(!0);
};
q.prototype.cleanup = function(e) {
  if (!(typeof this.xhr > "u" || this.xhr === null)) {
    if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = rt : this.xhr.onreadystatechange = rt, e)
      try {
        this.xhr.abort();
      } catch {
      }
    typeof document < "u" && delete q.requests[this.index], this.xhr = null;
  }
};
q.prototype.onLoad = function() {
  var e;
  try {
    var t;
    try {
      t = this.xhr.getResponseHeader("Content-Type");
    } catch {
    }
    t === "application/octet-stream" || t === "application/octet-stream; charset=UTF-8" ? e = this.xhr.response || this.xhr.responseText : e = this.xhr.responseText;
  } catch (r) {
    this.onError(r);
  }
  e != null && this.onData(e);
};
q.prototype.hasXDR = function() {
  return typeof XDomainRequest < "u" && !this.xs && this.enablesXDR;
};
q.prototype.abort = function() {
  this.cleanup();
};
q.requestsCount = 0;
q.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", nt);
  else if (typeof addEventListener == "function") {
    var Or = "onpagehide" in Nr ? "pagehide" : "unload";
    addEventListener(Or, nt, !1);
  }
}
function nt() {
  for (var e in q.requests)
    q.requests.hasOwnProperty(e) && q.requests[e].abort();
}
var Ir = He.exports, ze = kt, Rr = Ce, it = Me, xr = re, Tr = /\n/g, Dr = /\\n/g, he;
function qr() {
}
function re(e) {
  ze.call(this, e), this.query = this.query || {}, he || (he = it.___eio = it.___eio || []), this.index = he.length;
  var t = this;
  he.push(function(r) {
    t.onData(r);
  }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
    t.script && (t.script.onerror = qr);
  }, !1);
}
Rr(re, ze);
re.prototype.supportsBinary = !1;
re.prototype.doClose = function() {
  this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), ze.prototype.doClose.call(this);
};
re.prototype.doPoll = function() {
  var e = this, t = document.createElement("script");
  this.script && (this.script.parentNode.removeChild(this.script), this.script = null), t.async = !0, t.src = this.uri(), t.onerror = function(i) {
    e.onError("jsonp poll error", i);
  };
  var r = document.getElementsByTagName("script")[0];
  r ? r.parentNode.insertBefore(t, r) : (document.head || document.body).appendChild(t), this.script = t;
  var n = typeof navigator < "u" && /gecko/i.test(navigator.userAgent);
  n && setTimeout(function() {
    var i = document.createElement("iframe");
    document.body.appendChild(i), document.body.removeChild(i);
  }, 100);
};
re.prototype.doWrite = function(e, t) {
  var r = this;
  if (!this.form) {
    var n = document.createElement("form"), i = document.createElement("textarea"), o = this.iframeId = "eio_iframe_" + this.index, s;
    n.className = "socketio", n.style.position = "absolute", n.style.top = "-1000px", n.style.left = "-1000px", n.target = o, n.method = "POST", n.setAttribute("accept-charset", "utf-8"), i.name = "d", n.appendChild(i), document.body.appendChild(n), this.form = n, this.area = i;
  }
  this.form.action = this.uri();
  function f() {
    h(), t();
  }
  function h() {
    if (r.iframe)
      try {
        r.form.removeChild(r.iframe);
      } catch (p) {
        r.onError("jsonp polling iframe removal error", p);
      }
    try {
      var u = '<iframe src="javascript:0" name="' + r.iframeId + '">';
      s = document.createElement(u);
    } catch {
      s = document.createElement("iframe"), s.name = r.iframeId, s.src = "javascript:0";
    }
    s.id = r.iframeId, r.form.appendChild(s), r.iframe = s;
  }
  h(), e = e.replace(Dr, `\\
`), this.area.value = e.replace(Tr, "\\n");
  try {
    this.form.submit();
  } catch {
  }
  this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
    r.iframe.readyState === "complete" && f();
  } : this.iframe.onload = f;
};
const Pr = {}, _r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pr
}, Symbol.toStringTag, { value: "Module" })), Ur = /* @__PURE__ */ _t(_r);
var je = Xe(), Lr = K, Mr = we(), $r = Ce, Hr = At, Xr = X("engine.io-client:websocket"), ge, Je;
typeof WebSocket < "u" ? ge = WebSocket : typeof self < "u" && (ge = self.WebSocket || self.MozWebSocket);
if (typeof window > "u")
  try {
    Je = Ur;
  } catch {
  }
var Z = ge || Je, Wr = M;
function M(e) {
  var t = e && e.forceBase64;
  t && (this.supportsBinary = !1), this.perMessageDeflate = e.perMessageDeflate, this.usingBrowserWebSocket = ge && !e.forceNode, this.protocols = e.protocols, this.usingBrowserWebSocket || (Z = Je), je.call(this, e);
}
$r(M, je);
M.prototype.name = "websocket";
M.prototype.supportsBinary = !0;
M.prototype.doOpen = function() {
  if (this.check()) {
    var e = this.uri(), t = this.protocols, r = {};
    this.isReactNative || (r.agent = this.agent, r.perMessageDeflate = this.perMessageDeflate, r.pfx = this.pfx, r.key = this.key, r.passphrase = this.passphrase, r.cert = this.cert, r.ca = this.ca, r.ciphers = this.ciphers, r.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (r.headers = this.extraHeaders), this.localAddress && (r.localAddress = this.localAddress);
    try {
      this.ws = this.usingBrowserWebSocket && !this.isReactNative ? t ? new Z(e, t) : new Z(e) : new Z(e, t, r);
    } catch (n) {
      return this.emit("error", n);
    }
    this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
  }
};
M.prototype.addEventListeners = function() {
  var e = this;
  this.ws.onopen = function() {
    e.onOpen();
  }, this.ws.onclose = function() {
    e.onClose();
  }, this.ws.onmessage = function(t) {
    e.onData(t.data);
  }, this.ws.onerror = function(t) {
    e.onError("websocket error", t);
  };
};
M.prototype.write = function(e) {
  var t = this;
  this.writable = !1;
  for (var r = e.length, n = 0, i = r; n < i; n++)
    (function(s) {
      Lr.encodePacket(s, t.supportsBinary, function(f) {
        if (!t.usingBrowserWebSocket) {
          var h = {};
          if (s.options && (h.compress = s.options.compress), t.perMessageDeflate) {
            var u = typeof f == "string" ? Buffer.byteLength(f) : f.length;
            u < t.perMessageDeflate.threshold && (h.compress = !1);
          }
        }
        try {
          t.usingBrowserWebSocket ? t.ws.send(f) : t.ws.send(f, h);
        } catch {
          Xr("websocket closed before onclose event");
        }
        --r || o();
      });
    })(e[n]);
  function o() {
    t.emit("flush"), setTimeout(function() {
      t.writable = !0, t.emit("drain");
    }, 0);
  }
};
M.prototype.onClose = function() {
  je.prototype.onClose.call(this);
};
M.prototype.doClose = function() {
  typeof this.ws < "u" && this.ws.close();
};
M.prototype.uri = function() {
  var e = this.query || {}, t = this.secure ? "wss" : "ws", r = "";
  this.port && (t === "wss" && Number(this.port) !== 443 || t === "ws" && Number(this.port) !== 80) && (r = ":" + this.port), this.timestampRequests && (e[this.timestampParam] = Hr()), this.supportsBinary || (e.b64 = 1), e = Mr.encode(e), e.length && (e = "?" + e);
  var n = this.hostname.indexOf(":") !== -1;
  return t + "://" + (n ? "[" + this.hostname + "]" : this.hostname) + r + this.path + e;
};
M.prototype.check = function() {
  return !!Z && !("__initialize" in Z && this.name === M.prototype.name);
};
var zr = $e, jr = Ir, Jr = xr, Vr = Wr;
be.polling = Gr;
be.websocket = Vr;
function Gr(e) {
  var t, r = !1, n = !1, i = e.jsonp !== !1;
  if (typeof location < "u") {
    var o = location.protocol === "https:", s = location.port;
    s || (s = o ? 443 : 80), r = e.hostname !== location.hostname || s !== e.port, n = e.secure !== o;
  }
  if (e.xdomain = r, e.xscheme = n, t = new zr(e), "open" in t && !e.forceJSONP)
    return new jr(e);
  if (!i)
    throw new Error("JSONP disabled");
  return new Jr(e);
}
var Kr = [].indexOf, Ft = function(e, t) {
  if (Kr)
    return e.indexOf(t);
  for (var r = 0; r < e.length; ++r)
    if (e[r] === t)
      return r;
  return -1;
}, Yr = be, Qr = ee, D = X("engine.io-client:socket"), Zr = Ft, Nt = K, ot = lt, en = we(), tn = B;
function B(e, t) {
  if (!(this instanceof B))
    return new B(e, t);
  t = t || {}, e && typeof e == "object" && (t = e, e = null), e ? (e = ot(e), t.hostname = e.host, t.secure = e.protocol === "https" || e.protocol === "wss", t.port = e.port, e.query && (t.query = e.query)) : t.host && (t.hostname = ot(t.host).host), this.secure = t.secure != null ? t.secure : typeof location < "u" && location.protocol === "https:", t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.agent = t.agent || !1, this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? 443 : 80), this.query = t.query || {}, typeof this.query == "string" && (this.query = en.decode(this.query)), this.upgrade = t.upgrade !== !1, this.path = (t.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!t.forceJSONP, this.jsonp = t.jsonp !== !1, this.forceBase64 = !!t.forceBase64, this.enablesXDR = !!t.enablesXDR, this.withCredentials = t.withCredentials !== !1, this.timestampParam = t.timestampParam || "t", this.timestampRequests = t.timestampRequests, this.transports = t.transports || ["polling", "websocket"], this.transportOptions = t.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = t.policyPort || 843, this.rememberUpgrade = t.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = t.onlyBinaryUpgrades, this.perMessageDeflate = t.perMessageDeflate !== !1 ? t.perMessageDeflate || {} : !1, this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = t.pfx || void 0, this.key = t.key || void 0, this.passphrase = t.passphrase || void 0, this.cert = t.cert || void 0, this.ca = t.ca || void 0, this.ciphers = t.ciphers || void 0, this.rejectUnauthorized = t.rejectUnauthorized === void 0 ? !0 : t.rejectUnauthorized, this.forceNode = !!t.forceNode, this.isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self > "u" || this.isReactNative) && (t.extraHeaders && Object.keys(t.extraHeaders).length > 0 && (this.extraHeaders = t.extraHeaders), t.localAddress && (this.localAddress = t.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
}
B.priorWebsocketSuccess = !1;
Qr(B.prototype);
B.protocol = Nt.protocol;
B.Socket = B;
B.Transport = Xe();
B.transports = be;
B.parser = K;
B.prototype.createTransport = function(e) {
  D('creating transport "%s"', e);
  var t = rn(this.query);
  t.EIO = Nt.protocol, t.transport = e;
  var r = this.transportOptions[e] || {};
  this.id && (t.sid = this.id);
  var n = new Yr[e]({
    query: t,
    socket: this,
    agent: r.agent || this.agent,
    hostname: r.hostname || this.hostname,
    port: r.port || this.port,
    secure: r.secure || this.secure,
    path: r.path || this.path,
    forceJSONP: r.forceJSONP || this.forceJSONP,
    jsonp: r.jsonp || this.jsonp,
    forceBase64: r.forceBase64 || this.forceBase64,
    enablesXDR: r.enablesXDR || this.enablesXDR,
    withCredentials: r.withCredentials || this.withCredentials,
    timestampRequests: r.timestampRequests || this.timestampRequests,
    timestampParam: r.timestampParam || this.timestampParam,
    policyPort: r.policyPort || this.policyPort,
    pfx: r.pfx || this.pfx,
    key: r.key || this.key,
    passphrase: r.passphrase || this.passphrase,
    cert: r.cert || this.cert,
    ca: r.ca || this.ca,
    ciphers: r.ciphers || this.ciphers,
    rejectUnauthorized: r.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: r.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: r.extraHeaders || this.extraHeaders,
    forceNode: r.forceNode || this.forceNode,
    localAddress: r.localAddress || this.localAddress,
    requestTimeout: r.requestTimeout || this.requestTimeout,
    protocols: r.protocols || void 0,
    isReactNative: this.isReactNative
  });
  return n;
};
function rn(e) {
  var t = {};
  for (var r in e)
    e.hasOwnProperty(r) && (t[r] = e[r]);
  return t;
}
B.prototype.open = function() {
  var e;
  if (this.rememberUpgrade && B.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
    e = "websocket";
  else if (this.transports.length === 0) {
    var t = this;
    setTimeout(function() {
      t.emit("error", "No transports available");
    }, 0);
    return;
  } else
    e = this.transports[0];
  this.readyState = "opening";
  try {
    e = this.createTransport(e);
  } catch {
    this.transports.shift(), this.open();
    return;
  }
  e.open(), this.setTransport(e);
};
B.prototype.setTransport = function(e) {
  D("setting transport %s", e.name);
  var t = this;
  this.transport && (D("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = e, e.on("drain", function() {
    t.onDrain();
  }).on("packet", function(r) {
    t.onPacket(r);
  }).on("error", function(r) {
    t.onError(r);
  }).on("close", function() {
    t.onClose("transport close");
  });
};
B.prototype.probe = function(e) {
  D('probing transport "%s"', e);
  var t = this.createTransport(e, { probe: 1 }), r = !1, n = this;
  B.priorWebsocketSuccess = !1;
  function i() {
    if (n.onlyBinaryUpgrades) {
      var d = !this.supportsBinary && n.transport.supportsBinary;
      r = r || d;
    }
    r || (D('probe transport "%s" opened', e), t.send([{ type: "ping", data: "probe" }]), t.once("packet", function(y) {
      if (!r)
        if (y.type === "pong" && y.data === "probe") {
          if (D('probe transport "%s" pong', e), n.upgrading = !0, n.emit("upgrading", t), !t)
            return;
          B.priorWebsocketSuccess = t.name === "websocket", D('pausing current transport "%s"', n.transport.name), n.transport.pause(function() {
            r || n.readyState !== "closed" && (D("changing transport and sending upgrade packet"), p(), n.setTransport(t), t.send([{ type: "upgrade" }]), n.emit("upgrade", t), t = null, n.upgrading = !1, n.flush());
          });
        } else {
          D('probe transport "%s" failed', e);
          var a = new Error("probe error");
          a.transport = t.name, n.emit("upgradeError", a);
        }
    }));
  }
  function o() {
    r || (r = !0, p(), t.close(), t = null);
  }
  function s(d) {
    var y = new Error("probe error: " + d);
    y.transport = t.name, o(), D('probe transport "%s" failed because of error: %s', e, d), n.emit("upgradeError", y);
  }
  function f() {
    s("transport closed");
  }
  function h() {
    s("socket closed");
  }
  function u(d) {
    t && d.name !== t.name && (D('"%s" works - aborting "%s"', d.name, t.name), o());
  }
  function p() {
    t.removeListener("open", i), t.removeListener("error", s), t.removeListener("close", f), n.removeListener("close", h), n.removeListener("upgrading", u);
  }
  t.once("open", i), t.once("error", s), t.once("close", f), this.once("close", h), this.once("upgrading", u), t.open();
};
B.prototype.onOpen = function() {
  if (D("socket open"), this.readyState = "open", B.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
    D("starting upgrade probes");
    for (var e = 0, t = this.upgrades.length; e < t; e++)
      this.probe(this.upgrades[e]);
  }
};
B.prototype.onPacket = function(e) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
    switch (D('socket receive: type "%s", data "%s"', e.type, e.data), this.emit("packet", e), this.emit("heartbeat"), e.type) {
      case "open":
        this.onHandshake(JSON.parse(e.data));
        break;
      case "pong":
        this.setPing(), this.emit("pong");
        break;
      case "error":
        var t = new Error("server error");
        t.code = e.data, this.onError(t);
        break;
      case "message":
        this.emit("data", e.data), this.emit("message", e.data);
        break;
    }
  else
    D('packet received with socket readyState "%s"', this.readyState);
};
B.prototype.onHandshake = function(e) {
  this.emit("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
};
B.prototype.onHeartbeat = function(e) {
  clearTimeout(this.pingTimeoutTimer);
  var t = this;
  t.pingTimeoutTimer = setTimeout(function() {
    t.readyState !== "closed" && t.onClose("ping timeout");
  }, e || t.pingInterval + t.pingTimeout);
};
B.prototype.setPing = function() {
  var e = this;
  clearTimeout(e.pingIntervalTimer), e.pingIntervalTimer = setTimeout(function() {
    D("writing ping packet - expecting pong within %sms", e.pingTimeout), e.ping(), e.onHeartbeat(e.pingTimeout);
  }, e.pingInterval);
};
B.prototype.ping = function() {
  var e = this;
  this.sendPacket("ping", function() {
    e.emit("ping");
  });
};
B.prototype.onDrain = function() {
  this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
};
B.prototype.flush = function() {
  this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (D("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
};
B.prototype.write = B.prototype.send = function(e, t, r) {
  return this.sendPacket("message", e, t, r), this;
};
B.prototype.sendPacket = function(e, t, r, n) {
  if (typeof t == "function" && (n = t, t = void 0), typeof r == "function" && (n = r, r = null), !(this.readyState === "closing" || this.readyState === "closed")) {
    r = r || {}, r.compress = r.compress !== !1;
    var i = {
      type: e,
      data: t,
      options: r
    };
    this.emit("packetCreate", i), this.writeBuffer.push(i), n && this.once("flush", n), this.flush();
  }
};
B.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.readyState = "closing";
    var e = this;
    this.writeBuffer.length ? this.once("drain", function() {
      this.upgrading ? n() : t();
    }) : this.upgrading ? n() : t();
  }
  function t() {
    e.onClose("forced close"), D("socket closing - telling transport to close"), e.transport.close();
  }
  function r() {
    e.removeListener("upgrade", r), e.removeListener("upgradeError", r), t();
  }
  function n() {
    e.once("upgrade", r), e.once("upgradeError", r);
  }
  return this;
};
B.prototype.onError = function(e) {
  D("socket error %j", e), B.priorWebsocketSuccess = !1, this.emit("error", e), this.onClose("transport error", e);
};
B.prototype.onClose = function(e, t) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    D('socket close with reason: "%s"', e);
    var r = this;
    clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", e, t), r.writeBuffer = [], r.prevBufferLen = 0;
  }
};
B.prototype.filterUpgrades = function(e) {
  for (var t = [], r = 0, n = e.length; r < n; r++)
    ~Zr(this.transports, e[r]) && t.push(e[r]);
  return t;
};
Le.exports = tn;
Le.exports.parser = K;
var nn = Le.exports, Se = { exports: {} }, Fe, st;
function on() {
  if (st)
    return Fe;
  st = 1, Fe = e;
  function e(t, r) {
    var n = [];
    r = r || 0;
    for (var i = r || 0; i < t.length; i++)
      n[i - r] = t[i];
    return n;
  }
  return Fe;
}
var Ot = sn;
function sn(e, t, r) {
  return e.on(t, r), {
    destroy: function() {
      e.removeListener(t, r);
    }
  };
}
var at = [].slice, It = function(e, t) {
  if (typeof t == "string" && (t = e[t]), typeof t != "function")
    throw new Error("bind() requires a function");
  var r = at.call(arguments, 2);
  return function() {
    return t.apply(e, r.concat(at.call(arguments)));
  };
}, ct;
function Rt() {
  return ct || (ct = 1, function(e, t) {
    var r = ve, n = ee, i = on(), o = Ot, s = It, f = X("socket.io-client:socket"), h = we(), u = vt();
    e.exports = y;
    var p = {
      connect: 1,
      connect_error: 1,
      connect_timeout: 1,
      connecting: 1,
      disconnect: 1,
      error: 1,
      reconnect: 1,
      reconnect_attempt: 1,
      reconnect_failed: 1,
      reconnect_error: 1,
      reconnecting: 1,
      ping: 1,
      pong: 1
    }, d = n.prototype.emit;
    function y(a, N, k) {
      this.io = a, this.nsp = N, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, k && k.query && (this.query = k.query), this.io.autoConnect && this.open();
    }
    n(y.prototype), y.prototype.subEvents = function() {
      if (!this.subs) {
        var a = this.io;
        this.subs = [
          o(a, "open", s(this, "onopen")),
          o(a, "packet", s(this, "onpacket")),
          o(a, "close", s(this, "onclose"))
        ];
      }
    }, y.prototype.open = y.prototype.connect = function() {
      return this.connected ? this : (this.subEvents(), this.io.reconnecting || this.io.open(), this.io.readyState === "open" && this.onopen(), this.emit("connecting"), this);
    }, y.prototype.send = function() {
      var a = i(arguments);
      return a.unshift("message"), this.emit.apply(this, a), this;
    }, y.prototype.emit = function(a) {
      if (p.hasOwnProperty(a))
        return d.apply(this, arguments), this;
      var N = i(arguments), k = {
        type: (this.flags.binary !== void 0 ? this.flags.binary : u(N)) ? r.BINARY_EVENT : r.EVENT,
        data: N
      };
      return k.options = {}, k.options.compress = !this.flags || this.flags.compress !== !1, typeof N[N.length - 1] == "function" && (f("emitting packet with ack id %d", this.ids), this.acks[this.ids] = N.pop(), k.id = this.ids++), this.connected ? this.packet(k) : this.sendBuffer.push(k), this.flags = {}, this;
    }, y.prototype.packet = function(a) {
      a.nsp = this.nsp, this.io.packet(a);
    }, y.prototype.onopen = function() {
      if (f("transport is open - connecting"), this.nsp !== "/")
        if (this.query) {
          var a = typeof this.query == "object" ? h.encode(this.query) : this.query;
          f("sending connect packet with query %s", a), this.packet({ type: r.CONNECT, query: a });
        } else
          this.packet({ type: r.CONNECT });
    }, y.prototype.onclose = function(a) {
      f("close (%s)", a), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", a);
    }, y.prototype.onpacket = function(a) {
      var N = a.nsp === this.nsp, k = a.type === r.ERROR && a.nsp === "/";
      if (!(!N && !k))
        switch (a.type) {
          case r.CONNECT:
            this.onconnect();
            break;
          case r.EVENT:
            this.onevent(a);
            break;
          case r.BINARY_EVENT:
            this.onevent(a);
            break;
          case r.ACK:
            this.onack(a);
            break;
          case r.BINARY_ACK:
            this.onack(a);
            break;
          case r.DISCONNECT:
            this.ondisconnect();
            break;
          case r.ERROR:
            this.emit("error", a.data);
            break;
        }
    }, y.prototype.onevent = function(a) {
      var N = a.data || [];
      f("emitting event %j", N), a.id != null && (f("attaching ack callback to event"), N.push(this.ack(a.id))), this.connected ? d.apply(this, N) : this.receiveBuffer.push(N);
    }, y.prototype.ack = function(a) {
      var N = this, k = !1;
      return function() {
        if (!k) {
          k = !0;
          var l = i(arguments);
          f("sending ack %j", l), N.packet({
            type: u(l) ? r.BINARY_ACK : r.ACK,
            id: a,
            data: l
          });
        }
      };
    }, y.prototype.onack = function(a) {
      var N = this.acks[a.id];
      typeof N == "function" ? (f("calling ack %s with %j", a.id, a.data), N.apply(this, a.data), delete this.acks[a.id]) : f("bad ack %s", a.id);
    }, y.prototype.onconnect = function() {
      this.connected = !0, this.disconnected = !1, this.emitBuffered(), this.emit("connect");
    }, y.prototype.emitBuffered = function() {
      var a;
      for (a = 0; a < this.receiveBuffer.length; a++)
        d.apply(this, this.receiveBuffer[a]);
      for (this.receiveBuffer = [], a = 0; a < this.sendBuffer.length; a++)
        this.packet(this.sendBuffer[a]);
      this.sendBuffer = [];
    }, y.prototype.ondisconnect = function() {
      f("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
    }, y.prototype.destroy = function() {
      if (this.subs) {
        for (var a = 0; a < this.subs.length; a++)
          this.subs[a].destroy();
        this.subs = null;
      }
      this.io.destroy(this);
    }, y.prototype.close = y.prototype.disconnect = function() {
      return this.connected && (f("performing disconnect (%s)", this.nsp), this.packet({ type: r.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }, y.prototype.compress = function(a) {
      return this.flags.compress = a, this;
    }, y.prototype.binary = function(a) {
      return this.flags.binary = a, this;
    };
  }(Se)), Se.exports;
}
var an = ne;
function ne(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
ne.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), r = Math.floor(t * this.jitter * e);
    e = Math.floor(t * 10) & 1 ? e + r : e - r;
  }
  return Math.min(e, this.max) | 0;
};
ne.prototype.reset = function() {
  this.attempts = 0;
};
ne.prototype.setMin = function(e) {
  this.ms = e;
};
ne.prototype.setMax = function(e) {
  this.max = e;
};
ne.prototype.setJitter = function(e) {
  this.jitter = e;
};
var cn = nn, un = Rt(), fn = ee, hn = ve, W = Ot, Q = It, U = X("socket.io-client:manager"), xt = Ft, ln = an, Tt = Object.prototype.hasOwnProperty, ut = F;
function F(e, t) {
  if (!(this instanceof F))
    return new F(e, t);
  e && typeof e == "object" && (t = e, e = void 0), t = t || {}, t.path = t.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = t, this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(t.randomizationFactor || 0.5), this.backoff = new ln({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  }), this.timeout(t.timeout == null ? 2e4 : t.timeout), this.readyState = "closed", this.uri = e, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
  var r = t.parser || hn;
  this.encoder = new r.Encoder(), this.decoder = new r.Decoder(), this.autoConnect = t.autoConnect !== !1, this.autoConnect && this.open();
}
F.prototype.emitAll = function() {
  this.emit.apply(this, arguments);
  for (var e in this.nsps)
    Tt.call(this.nsps, e) && this.nsps[e].emit.apply(this.nsps[e], arguments);
};
F.prototype.updateSocketIds = function() {
  for (var e in this.nsps)
    Tt.call(this.nsps, e) && (this.nsps[e].id = this.generateId(e));
};
F.prototype.generateId = function(e) {
  return (e === "/" ? "" : e + "#") + this.engine.id;
};
fn(F.prototype);
F.prototype.reconnection = function(e) {
  return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
};
F.prototype.reconnectionAttempts = function(e) {
  return arguments.length ? (this._reconnectionAttempts = e, this) : this._reconnectionAttempts;
};
F.prototype.reconnectionDelay = function(e) {
  return arguments.length ? (this._reconnectionDelay = e, this.backoff && this.backoff.setMin(e), this) : this._reconnectionDelay;
};
F.prototype.randomizationFactor = function(e) {
  return arguments.length ? (this._randomizationFactor = e, this.backoff && this.backoff.setJitter(e), this) : this._randomizationFactor;
};
F.prototype.reconnectionDelayMax = function(e) {
  return arguments.length ? (this._reconnectionDelayMax = e, this.backoff && this.backoff.setMax(e), this) : this._reconnectionDelayMax;
};
F.prototype.timeout = function(e) {
  return arguments.length ? (this._timeout = e, this) : this._timeout;
};
F.prototype.maybeReconnectOnOpen = function() {
  !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
};
F.prototype.open = F.prototype.connect = function(e, t) {
  if (U("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
    return this;
  U("opening %s", this.uri), this.engine = cn(this.uri, this.opts);
  var r = this.engine, n = this;
  this.readyState = "opening", this.skipReconnect = !1;
  var i = W(r, "open", function() {
    n.onopen(), e && e();
  }), o = W(r, "error", function(h) {
    if (U("connect_error"), n.cleanup(), n.readyState = "closed", n.emitAll("connect_error", h), e) {
      var u = new Error("Connection error");
      u.data = h, e(u);
    } else
      n.maybeReconnectOnOpen();
  });
  if (this._timeout !== !1) {
    var s = this._timeout;
    U("connect attempt will timeout after %d", s), s === 0 && i.destroy();
    var f = setTimeout(function() {
      U("connect attempt timed out after %d", s), i.destroy(), r.close(), r.emit("error", "timeout"), n.emitAll("connect_timeout", s);
    }, s);
    this.subs.push({
      destroy: function() {
        clearTimeout(f);
      }
    });
  }
  return this.subs.push(i), this.subs.push(o), this;
};
F.prototype.onopen = function() {
  U("open"), this.cleanup(), this.readyState = "open", this.emit("open");
  var e = this.engine;
  this.subs.push(W(e, "data", Q(this, "ondata"))), this.subs.push(W(e, "ping", Q(this, "onping"))), this.subs.push(W(e, "pong", Q(this, "onpong"))), this.subs.push(W(e, "error", Q(this, "onerror"))), this.subs.push(W(e, "close", Q(this, "onclose"))), this.subs.push(W(this.decoder, "decoded", Q(this, "ondecoded")));
};
F.prototype.onping = function() {
  this.lastPing = /* @__PURE__ */ new Date(), this.emitAll("ping");
};
F.prototype.onpong = function() {
  this.emitAll("pong", /* @__PURE__ */ new Date() - this.lastPing);
};
F.prototype.ondata = function(e) {
  this.decoder.add(e);
};
F.prototype.ondecoded = function(e) {
  this.emit("packet", e);
};
F.prototype.onerror = function(e) {
  U("error", e), this.emitAll("error", e);
};
F.prototype.socket = function(e, t) {
  var r = this.nsps[e];
  if (!r) {
    r = new un(this, e, t), this.nsps[e] = r;
    var n = this;
    r.on("connecting", i), r.on("connect", function() {
      r.id = n.generateId(e);
    }), this.autoConnect && i();
  }
  function i() {
    ~xt(n.connecting, r) || n.connecting.push(r);
  }
  return r;
};
F.prototype.destroy = function(e) {
  var t = xt(this.connecting, e);
  ~t && this.connecting.splice(t, 1), !this.connecting.length && this.close();
};
F.prototype.packet = function(e) {
  U("writing packet %j", e);
  var t = this;
  e.query && e.type === 0 && (e.nsp += "?" + e.query), t.encoding ? t.packetBuffer.push(e) : (t.encoding = !0, this.encoder.encode(e, function(r) {
    for (var n = 0; n < r.length; n++)
      t.engine.write(r[n], e.options);
    t.encoding = !1, t.processPacketQueue();
  }));
};
F.prototype.processPacketQueue = function() {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var e = this.packetBuffer.shift();
    this.packet(e);
  }
};
F.prototype.cleanup = function() {
  U("cleanup");
  for (var e = this.subs.length, t = 0; t < e; t++) {
    var r = this.subs.shift();
    r.destroy();
  }
  this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
};
F.prototype.close = F.prototype.disconnect = function() {
  U("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, this.readyState === "opening" && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
};
F.prototype.onclose = function(e) {
  U("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", e), this._reconnection && !this.skipReconnect && this.reconnect();
};
F.prototype.reconnect = function() {
  if (this.reconnecting || this.skipReconnect)
    return this;
  var e = this;
  if (this.backoff.attempts >= this._reconnectionAttempts)
    U("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
  else {
    var t = this.backoff.duration();
    U("will wait %dms before reconnect attempt", t), this.reconnecting = !0;
    var r = setTimeout(function() {
      e.skipReconnect || (U("attempting reconnect"), e.emitAll("reconnect_attempt", e.backoff.attempts), e.emitAll("reconnecting", e.backoff.attempts), !e.skipReconnect && e.open(function(n) {
        n ? (U("reconnect attempt error"), e.reconnecting = !1, e.reconnect(), e.emitAll("reconnect_error", n.data)) : (U("reconnect success"), e.onreconnect());
      }));
    }, t);
    this.subs.push({
      destroy: function() {
        clearTimeout(r);
      }
    });
  }
};
F.prototype.onreconnect = function() {
  var e = this.backoff.attempts;
  this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", e);
};
(function(e, t) {
  var r = Gt, n = ve, i = ut, o = X("socket.io-client");
  e.exports = t = f;
  var s = t.managers = {};
  function f(h, u) {
    typeof h == "object" && (u = h, h = void 0), u = u || {};
    var p = r(h), d = p.source, y = p.id, a = p.path, N = s[y] && a in s[y].nsps, k = u.forceNew || u["force new connection"] || u.multiplex === !1 || N, l;
    return k ? (o("ignoring socket cache for %s", d), l = i(d, u)) : (s[y] || (o("new io instance for %s", d), s[y] = i(d, u)), l = s[y]), p.query && !u.query && (u.query = p.query), l.socket(p.path, u);
  }
  t.protocol = n.protocol, t.connect = f, t.Manager = ut, t.Socket = Rt();
})(Oe, Oe.exports);
var pn = Oe.exports;
const dn = /* @__PURE__ */ Pt(pn);
let le;
const yn = new Uint8Array(16);
function gn() {
  if (!le && (le = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !le))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return le(yn);
}
const P = [];
for (let e = 0; e < 256; ++e)
  P.push((e + 256).toString(16).slice(1));
function vn(e, t = 0) {
  return P[e[t + 0]] + P[e[t + 1]] + P[e[t + 2]] + P[e[t + 3]] + "-" + P[e[t + 4]] + P[e[t + 5]] + "-" + P[e[t + 6]] + P[e[t + 7]] + "-" + P[e[t + 8]] + P[e[t + 9]] + "-" + P[e[t + 10]] + P[e[t + 11]] + P[e[t + 12]] + P[e[t + 13]] + P[e[t + 14]] + P[e[t + 15]];
}
const mn = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ft = {
  randomUUID: mn
};
function bn(e, t, r) {
  if (ft.randomUUID && !t && !e)
    return ft.randomUUID();
  e = e || {};
  const n = e.random || (e.rng || gn)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    r = r || 0;
    for (let i = 0; i < 16; ++i)
      t[r + i] = n[i];
    return t;
  }
  return vn(n);
}
function wn(e, t) {
  const r = t.map((i) => JSON.stringify(i)).join(" "), n = (/* @__PURE__ */ new Date()).toISOString();
  return JSON.stringify({
    level: e,
    time: n,
    message: r
  });
}
function Cn(e, t) {
  const r = JSON.parse(e);
  return t.forEach((n) => delete r[n]), r;
}
function An(e) {
  if (typeof e == "object" && e !== null)
    return e;
  try {
    return JSON.parse(e);
  } catch {
    return { extraData: e };
  }
}
function En(e) {
  const t = /\(([^)]+)\)/, r = e.match(t);
  if (r && r[1]) {
    const n = r[1].split(";");
    for (let i of n)
      if (i = i.trim(), i.startsWith("Windows") || i.startsWith("Macintosh") || i.startsWith("Linux"))
        return i;
  }
  return "Unknown";
}
function ht(e) {
  return (...t) => new Promise((r, n) => {
    try {
      const i = e(...t);
      r(i);
    } catch (i) {
      n(i);
    }
  });
}
const Bn = {
  reconnection: !0,
  reconnectionDelay: 5e3,
  reconnectionAttempts: 10,
  //perMessageDeflate: false,
  upgrade: !1,
  transports: ["websocket"],
  debug: !1
}, Ne = {
  logToConsole: !0,
  overloadGlobalConsole: !1,
  socketEmitInterval: 6e4
}, Fn = {
  CREATE: "Create",
  READ: "Read",
  UPDATE: "Update",
  DELETE: "Delete",
  CONVERT: "Convert",
  DOWNLOAD: "Download",
  UPLOAD: "Upload",
  ENCRYPT: "Encrypt",
  DECRYPT: "Decrypt",
  FILTER: "Filter",
  INPUT: "Input",
  OUTPUT: "Output",
  PLUGIN: "Plugin",
  LOGIN: "Login",
  LOGOUT: "Logout",
  REFRESH: "Refresh",
  CHECK: "Check",
  WEBHOOK: "Webhook",
  WSCONNECT: "WSConnect"
}, kn = {
  Create: 1,
  Read: 2,
  Update: 3,
  Delete: 4,
  Convert: 5,
  Download: 6,
  Upload: 7,
  Encrypt: 8,
  Decrypt: 9,
  Filter: 10,
  Input: 11,
  Output: 12,
  Plugin: 13,
  Login: 14,
  Logout: 15,
  Refresh: 16,
  Check: 17,
  Webhook: 18,
  WSConnect: 19
}, Nn = {
  INFO: "info",
  WARNING: "warning",
  MODIFY: "modify",
  ERROR: "error",
  VIEW: "view"
}, On = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
  DEBUG: "debug"
}, In = {
  USER: "User",
  ACCOUNT: "Account"
}, Rn = {
  USER: "UserName",
  ACCOUNT: "AccountName",
  EXTENSION: "ExtensionName"
}, xn = {
  USER: "UserID",
  ACCOUNT: "AccountID",
  EXTENSION: "ExtensionID"
}, Tn = {
  USER: "User ID",
  ACCOUNT: "Account ID",
  EXTENSION: "Extension ID",
  CAMPAIGN: "Campaign ID",
  QUEUE: "Queue ID"
}, Dn = {
  USER: "User",
  ACCOUNT: "Account",
  EXTENSION: "Extension",
  CAMPAIGN: "Campaign",
  QUEUE: "Queue"
};
let L = console;
class qn {
  /**
   * Initialize storage logger
   * @param options The configuration of the logger.
   */
  constructor(t) {
    O(this, "logToConsole");
    O(this, "overloadGlobalConsole");
    O(this, "system");
    O(this, "socketEmitInterval");
    O(this, "storageId");
    O(this, "emitInProgress");
    O(this, "queue");
    O(this, "processing");
    O(this, "storageInitialized");
    O(this, "interval");
    O(this, "logIndex");
    O(this, "socket");
    O(this, "staticObject", {});
    O(this, "localObject", {});
    O(this, "isGetItemAsync");
    O(this, "isSetItemAsync");
    O(this, "getItem");
    O(this, "setItem");
    O(this, "parseLog");
    O(this, "_logMethod");
    O(this, "_warnMethod");
    O(this, "_errorMethod");
    O(this, "_debugMethod");
    const { loggerOptions: r } = t;
    if (!r.system)
      throw new Error("Config property 'system' should be provided!");
    this.isGetItemAsync = r.isGetItemAsync || !1, this.isSetItemAsync = r.isSetItemAsync || !1, this.setupStorageFunctions(r.getItem, r.setItem, r.parseLog), this.system = r.system, this.socketEmitInterval = r.socketEmitInterval || Ne.socketEmitInterval, this.logToConsole = r.logToConsole !== void 0 ? r.logToConsole : Ne.logToConsole, this.overloadGlobalConsole = r.overloadGlobalConsole !== void 0 ? r.overloadGlobalConsole : Ne.overloadGlobalConsole, this.storageId = this.getStorageName(), this.queue = [], this.processing = !1, this.storageInitialized = !1, this.emitInProgress = !1, this.logIndex = 0, this.init(t);
  }
  /**
   * Used to setup storage functions and logs parser function.
   * @param getItemFunction Function for getting item from storage.
   * @param setItemFunction Function for setting item to storage.
   * @param parseLogFunction Function for parsing logs.
   * @return void
   */
  setupStorageFunctions(t, r, n) {
    this.getItem = t && typeof t == "function" ? this.isGetItemAsync ? t : ht(t) : this.defaultGetItemFunction, this.setItem = r && typeof r == "function" ? this.isSetItemAsync ? r : ht(r) : this.defaultSetItemFunction, this.parseLog = n && typeof n == "function" ? n : wn;
  }
  /**
   * Used to initialize logger. Initializes storage, establishes socket connection and overloads console if needed
   * @param options The logger config.
   * @return void
   */
  init(t) {
    const { socket: r, url: n, socketOptions: i = {} } = t;
    this._logMethod = L.log.bind(L), this._warnMethod = L.warn.bind(L), this._errorMethod = L.error.bind(L), this._debugMethod = L.debug.bind(L), this.initStorage().then(() => {
      if (r)
        this.socket = r;
      else if (n)
        this.socket = this.createConnection(n, i);
      else
        throw new Error("Must provide either a 'socket' or a 'url' for socket connection");
      this.interval = setInterval(async () => {
        await this.emitLogs();
      }, this.socketEmitInterval), this.overloadGlobalConsole && this._overloadConsole();
    });
  }
  /**
   * Used to initialize new socket connection
   * @param url The url used for the socket connection.
   * @param options The options used for the socket connection.
   * @return void
   */
  createConnection(t, r = {}) {
    const n = {
      ...Bn,
      ...r
    };
    return dn(t, n);
  }
  /**
   * Emits stored logs to the server and clears the log storage in case the emit operation was successful
   * @return {Promise<void>}
   */
  async emitLogs() {
    if (!this.emitInProgress)
      try {
        const t = await this.getItem(this.storageId), r = JSON.parse(t || "{}"), n = {
          ...this.localObject,
          ...r
        };
        if (!Object.keys(n).length)
          return;
        const i = [];
        this.emitInProgress = !0;
        const o = Object.keys(n);
        if (!o.length)
          return;
        if (!this.socket || !this.socket.connected)
          throw new Error("Socket is disconnected");
        for (const h of o) {
          const u = An(n[h]), p = {
            ...this.staticObject,
            ...u
          }, d = this.populateSendingLog(p);
          await this.socket.emit("Log", JSON.stringify(d)), i.push(h);
        }
        const s = await this.getItem(this.storageId);
        if (!s)
          return;
        const f = Cn(s, i);
        this.localObject = {}, await this.setItem(this.storageId, JSON.stringify(f));
      } catch (t) {
        this._errorMethod(t);
      } finally {
        this.emitInProgress = !1;
      }
  }
  /**
   * Used to set additional properties for every sending log
   * @return LoggerDataInner
   */
  populateSendingLog(t) {
    const r = {
      ...t
    }, n = r.ActionName;
    return n && (r.ActionID = kn[n]), r;
  }
  /**
  * Used to set a static object which will be send in every message
  * @return void
  */
  setupStaticFields(t) {
    this.staticObject = { ...t };
  }
  /**
   * Used to populate sending message object with static client parameters
   * @return object
   */
  populateMetaData() {
    const t = /* @__PURE__ */ new Date();
    let r;
    typeof window < "u" && typeof window.document < "u" ? r = window == null ? void 0 : window.navigator.userAgent : typeof self < "u" && self.navigator && (r = self.navigator.userAgent);
    let n;
    return r && (n = En(r)), {
      System: this.system,
      DateTime: t,
      UserAgent: r,
      OSVersion: n
    };
  }
  /**
   * Used to stop logger and interrupt socket connection
   * @return void
   */
  async stop() {
    !this.socket || !this.socket.connected || (clearInterval(this.interval), await this.emitLogs(), this.socket.disconnect());
  }
  /**
   * Used to start logger and reconnect socket connection
   * @return void
   */
  async start() {
    this.socket && this.socket.connected || (this.socket.connect(), this.interval = setInterval(async () => {
      await this.emitLogs();
    }, this.socketEmitInterval));
  }
  /**
   * Used to overload the global console object by logger methods.
   * @return void
   */
  _overloadConsole() {
    L = Object.assign(
      L,
      {
        log: (t) => {
          this.log(t);
        },
        warn: (t) => {
          this.warn(t);
        },
        error: (t) => {
          this.error(t);
        },
        debug: (t) => {
          this.debug(t);
        }
      }
    );
  }
  /**
   * Used to initialize the storage if it wasn't created before.
   * @return void
   */
  async initStorage() {
    const t = await this.getItem(this.storageId);
    (!t || typeof t != "string") && (await this.setItem(this.storageId, JSON.stringify({})), this.storageInitialized = !0);
  }
  /**
   * Reset log storage
   * @return void
   */
  async resetStorage() {
    await this.setItem(this.storageId, JSON.stringify({}));
  }
  /**
   * Get storage name which is used to access the logs storage
   * @return string
   */
  getStorageName() {
    const t = bn();
    return this.system.toString().toUpperCase() + t + Date.now();
  }
  /**
   * Does common logic for logging data.
   * @param args The arguments of the log where the first argument contains the log level and other
   * arguments are logs to be stored
   * @return void
   */
  async processLog(...t) {
    try {
      if (t.length < 2)
        return;
      const r = t[0], n = t[1], i = this.formItemKey(r);
      if (!this.storageInitialized) {
        this.localObject = {
          ...this.localObject,
          [i]: n
        };
        return;
      }
      const o = await this.getItem(this.storageId);
      if (!o)
        return;
      const s = JSON.parse(o);
      s[i] = JSON.stringify(n), await this.setItem(this.storageId, JSON.stringify(s));
    } catch (r) {
      this._errorMethod(r);
    }
  }
  /**
   * Used to process logs queue.
   * @return Promise<void>
   */
  async processQueue() {
    if (this.processing || this.queue.length === 0)
      return;
    const t = this.queue.shift();
    t && (this.processing = !0, await this.processLog(...t).finally(() => {
      this.processing = !1, this.processQueue();
    }));
  }
  /**
   * Logs info data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  log(t) {
    const n = {
      ...this.populateMetaData(),
      ...t
    }, i = ["INFO", n];
    this.queue.push(i), this.logToConsole && this._logMethod.apply(L, [n]), this.processQueue();
  }
  /**
   * Logs warn data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  warn(t) {
    const r = ["WARN", t];
    this.queue.push(r), this.logToConsole && this._warnMethod.apply(L, [t]), this.processQueue();
  }
  /**
   * Logs error data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  error(t) {
    const r = ["ERROR", t];
    this.queue.push(r), this.logToConsole && this._errorMethod.apply(L, [t]), this.processQueue();
  }
  /**
   * Logs debug data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  debug(t) {
    const r = ["DEBUG", t];
    this.queue.push(r), this.logToConsole && this._debugMethod.apply(L, [t]), this.processQueue();
  }
  /**
   * The default method for getting logs from storage
   * @param storageId The identifier of storage where logs are stored.
   * @return string || null
   */
  async defaultGetItemFunction(t) {
    return localStorage.getItem(t);
  }
  /**
   * The default method for setting logs into the storage
   * @param storageId The identifier of storage where to store the logs.
   * @param logs The logs to be stored.
   * @return void
   */
  async defaultSetItemFunction(t, r) {
    try {
      localStorage.setItem(t, r);
    } catch (n) {
      this._errorMethod(n);
    }
  }
  /**
   * Used to form a key which will be used to store a log in the storage
   * @param level The log level. For example: Info, Warn, Error etc..
   * @return string
   */
  formItemKey(t) {
    const r = (/* @__PURE__ */ new Date()).toISOString();
    return this.logIndex++, `${t}-${this.system}-${r}-${this.logIndex}`;
  }
}
export {
  kn as ActionIDEnum,
  Fn as ActionNameEnum,
  Tn as EntityIDEnum,
  Dn as EntityTypeEnum,
  xn as IdentityIDEnum,
  Rn as IdentityNameEnum,
  In as IdentityTypeEnum,
  On as LevelEnum,
  Nn as LogTypeEnum,
  qn as default,
  Bn as defaultConnectOptions,
  Ne as defaultLoggerOptions
};
//# sourceMappingURL=storage-logger.es.js.map
